export enum AccordionActionVisibility {
  always = 'always',
  opened = 'opened',
  closed = 'closed'
}
